// extracted by mini-css-extract-plugin
module.exports = {"santa":"santa_santa__hY9lV","skiing":"santa_skiing__Z7zn7"};